import React, { useState } from 'react';
import { Switch } from '../../../core/ui';
import { useTranslation } from '../../../core/context/TranslationContext';
import { updateMyMembership } from '../api/family';
import { useFamily } from '../context/FamilyContext';
import styles from './ShareFlagToggle.module.css';

export default function ShareFlagToggle({ shareReceipts, shareBudget }) {
  const { t } = useTranslation();
  const { refresh } = useFamily();
  const [busy, setBusy] = useState(false);

  const toggle = async (field, value) => {
    if (busy) return;
    setBusy(true);
    try {
      await updateMyMembership({ [field]: value });
      await refresh();
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className={styles.row}>
      <Switch
        id="share-receipts"
        label={t('family.share.receipts')}
        checked={shareReceipts}
        disabled={busy}
        onChange={(e) => toggle('shareReceipts', e.target.checked)}
      />
      <Switch
        id="share-budget"
        label={t('family.share.budget')}
        checked={shareBudget}
        disabled={busy}
        onChange={(e) => toggle('shareBudget', e.target.checked)}
      />
    </div>
  );
}
